import React from 'react'
import { Link } from 'react-router-dom'

const NotFoundComponent = () => {
    return (
        <div className='d-flex flex-column flex-root'>
            <div className='app-main flex-column flex-row-fluid'>
                <div className='d-flex flex-column text-center'>
                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body py-15 py-lg-20">
                            <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
                            <div className="fw-semibold fs-6 text-gray-500 mb-7">We can't find that page.</div>
                            <div className="mb-3">
                                <img src="/media/svg/undraw/page_not_found.svg" className="mw-100 mh-200px theme-light-show" alt="" />
                            </div>
                            <div className="mb-0">
                                <Link className="btn btn-sm btn-primary" to="/dashboard">Return Home</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFoundComponent